import type { ComponentChildren } from 'preact';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { sidebarOpen } from '../store/global';

export function Layout({ children }: { children: ComponentChildren }) {
  const closeSidebar = () => (sidebarOpen.value = false);
  return (
    <div class="flex h-[100dvh] bg-background text-foreground overflow-hidden">
      <Sidebar />
      {/* Backdrop só renderiza em mobile quando drawer está aberta */}
      {sidebarOpen.value && (
        <div
          class="fixed inset-0 z-30 bg-foreground/30 md:hidden"
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}
      <div class="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main class="flex-1 overflow-auto">{children}</main>
      </div>
    </div>
  );
}
